import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
var StyledImg = styled.img.withConfig({
  displayName: "MediaThumbnailAtFrame__StyledImg",
  componentId: "vapor__sc-6q0rk4-0"
})(["position:absolute;background-color:", ";object-fit:cover;object-position:center;opacity:", ";overflow:hidden;pointer-events:none;&:hover{opacity:1;}"], theme.colors.background.secondary, function (p) {
  return p.$isInitiallyVisible ? 1 : 0;
});
/**
 * Shows one frame from a Media Pipeline `thumbScrub` sprite. For interactive
 * hover scrubbing, assign the position via `useMousePosition()` or instead use
 * `<MediaThumbnail />`. Note that every frame in a `thumbScrub` sprite is
 * 135px tall with 16:9 aspect ratio, regardless of source media frame size.
 *
 * @example
 *
 * ```jsx
 * const ref = React.useRef<HTMLDivElement>();
 * const positionX = useMousePosition(ref);
 * return (
 *   <div ref={ref}>
 *     <StyledMediaThumbnailAtFrame
 *       height={160}
 *       position={positionX / 240}
 *       src={asset.thumbs?.thumbScrub}
 *       width={240}
 *     />
 *   </div>
 * )
 * ```
 */

export function MediaThumbnailAtFrame(_ref) {
  var height = _ref.height,
      isInitiallyVisible = _ref.isInitiallyVisible,
      position = _ref.position,
      _ref$scrubSpriteFrame = _ref.scrubSpriteFrameCount,
      scrubSpriteFrameCount = _ref$scrubSpriteFrame === void 0 ? 50 : _ref$scrubSpriteFrame,
      src = _ref.src,
      style = _ref.style,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["height", "isInitiallyVisible", "position", "scrubSpriteFrameCount", "src", "style", "width"]);

  var frameIndexAtOffset = scrubSpriteFrameCount * position;
  var frameIndexMax = scrubSpriteFrameCount - 1;
  var frameIndex = Math.round(Math.max(0, Math.min(frameIndexMax, frameIndexAtOffset)));
  var scrubSpriteFrameHeight = width * 9 / 16;
  var frameOffsetTop = frameIndex * scrubSpriteFrameHeight;
  return /*#__PURE__*/React.createElement(StyledImg, _extends({
    $isInitiallyVisible: isInitiallyVisible,
    alt: "",
    height: Math.floor(height || 0),
    loading: "lazy",
    src: src,
    style: _objectSpread(_objectSpread({}, style), {}, {
      objectPosition: "center -".concat(frameOffsetTop, "px")
    }),
    width: Math.floor(width || 0)
  }, rest));
}